import { type NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export const redirectToHomeIfNoInsightsAccess: NavigationGuard = async () => {
  const authStore = useAuthStore();

  if (authStore.appAccess.nav.insights) {
    return true;
  } else {
    return { name: 'home' };
  }
};
